import CardItem from './CardItem'

import { edu, exp, coding, knowldge, html, css, js, react, node, express, mongodb, btstrap, py } from '../indexPics'

const items = [
    {
        title: "Education", position: 'left', img: edu, items: [
            { content: "Bachelor's degree : in 2021 with Very good grade", children: [] },
            { content: "Now :I’m studying Algebra and Cryptography (3rd Year) at USTHB", children: [] },
        ]
    },
    {
        title: "Experience", position: "right", img: exp, items: [
            { content: "Junior Front-End Developer", children: [] },
            { content: "Founder of crypto club 2023", children: [] },
            { content: "SG of crypto club and leader of web-dev team 2024", children: [] },
        ]
    },
    {
        title: "Coding", position: "left", img: coding, items: [], skills: [
            { percent: 90, name: 'HTML', img: html },
            { percent: 70, name: 'CSS', img: css },
            { percent: 60, name: 'JavaScript', img: js },
            { percent: 50, name: 'React', img: react },
            { percent: 40, name: 'Node.js', img: node },
            { percent: 40, name: 'Express.js', img: express },
            { percent: 30, name: 'MongoDB', img: mongodb },
            { percent: 60, name: 'Python', img: py },
            { percent: 70, name: 'Bootstrap', img: btstrap }
        ]
    },
    {
        title: "Knowldge", position: "right", img: knowldge, items: [
            { content: "web scraping with node js and python", children: [] },
            { content: "Problem solving", children: [] },
            { content: "Linear Algebra | Group theory | finite fields", children: [] },
            { content: "Cryptography with mathematic Knowledge ", children: [] },
            {
                content: "Languages :", children: [
                    { content: "Arabic", progress: 70, children: [] },
                    { content: "French", progress: 40, children: [] },
                    { content: "English", progress: 50, children: [] },
                ]
            },
        ]
    }
]


const Cards = () => {
    return (
        <>
            {items.map((item) => {
                return <CardItem
                    position={item.position}
                    img={item.img}
                    title={item.title}
                    items={item.items}
                    skills={item.skills}
                />
            })}

        </>
    )
}

export default Cards
